import DigitalMagazinePage, {
    loader,
} from '~/routes/_app.digital-magazines._index';
import { inheritMeta as meta } from '~/modules/seo';

export { loader, meta };
export default DigitalMagazinePage;
